import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type NavigationLinkPlacement =
  | 'breadcrumb'
  | 'meganav'
  | 'module'
  | 'module_cta'
  | 'phone_menu'
  | 'product_information'
  | 'related_categories';

export const MODULE_CTA_POSITION = 1;

export type NavigationLinkModuleType =
  | 'homepage-hot-deals'
  | 'homepage-marketplace-top-sellers'
  | 'homepage-popular-brands'
  | 'homepage-popular-products'
  | 'homepage-sub-brands'
  | 'homepage-top-categories'
  | 'homepage-upcoming-products';

export type NavigationLinkTargetProperties = {
  ancestor_labels?: string[];
  destination_path: string;
  label?: string;
  module_position?: number;
  module_type?: NavigationLinkModuleType;
  placement: NavigationLinkPlacement;
  position: number;
};

type EventData = {
  ancestorLabels?: string[];
  destinationPath: string;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  label?: string;
  modulePosition?: number;
  moduleType?: NavigationLinkModuleType;
  placement: NavigationLinkPlacement;
  position: number;
};

class NavigationLinkInteractionEvent extends InteractionEvent<
  EventData,
  NavigationLinkTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'navigation_link';
  }

  protected get keepalive(): boolean {
    return true;
  }

  protected getTargetProperties(): NavigationLinkTargetProperties {
    return {
      ancestor_labels: this.data.ancestorLabels,
      destination_path: this.destinationPath(),
      label: this.data.label,
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      placement: this.data.placement,
      position: this.data.position
    };
  }

  private destinationPath(): string {
    const url = new URL(
      this.data.destinationPath,
      'https://placeholder.invalid'
    );

    return `${url.pathname}${url.search}`;
  }
}

export default NavigationLinkInteractionEvent;
